import Http from '../http';

const prefix = '/social-proof';

export const getAllCampaigns = () => Http.authApi().get(`${prefix}`);

export const createCampaign = data => Http.authApi().post(`${prefix}/create-campaign`, data);



// WEBPACK FOOTER //
// ./src/js/services/integrations-internas/socialProof.js